export default __webpack_public_path__ + "static/media/red_pressed.57b9c981.png";